import { TKey } from "@/app/translations/TKey";
import { ProjectOverviewStats } from "@/app/types/project/ProjectOverview";
import { ProtectedPaths } from "@/app/vars/Routes";

export type FlowStageKey = "calls" | "offers" | "avatars" | "prospects" | "messages";

export type Point = [number, number];

export type FlowStage = {
  key: FlowStageKey;
  labelKey: TKey;
  path: string;
  statKey: keyof ProjectOverviewStats;
  // Screen placement (x/y in %): horizontal spread on desktop, vertical stack on mobile.
  position: Point;
  mobilePosition: Point;
};

export const FLOW_STAGES: FlowStage[] = [
  {
    key: "calls",
    labelKey: TKey.PROJECT_FLOW_CALLS,
    path: ProtectedPaths.CALL_ANALYSIS,
    statKey: "calls",
    position: [11, 32],
    mobilePosition: [34, 10],
  },
  {
    key: "offers",
    labelKey: TKey.PROJECT_FLOW_OFFERS,
    path: ProtectedPaths.OFFERS,
    statKey: "offers",
    position: [31, 70],
    mobilePosition: [64, 30],
  },
  {
    key: "avatars",
    labelKey: TKey.PROJECT_FLOW_AVATARS,
    path: ProtectedPaths.CLIENT_AVATAR,
    statKey: "avatars",
    position: [51, 24],
    mobilePosition: [34, 50],
  },
  {
    key: "prospects",
    labelKey: TKey.PROJECT_FLOW_PROSPECTS,
    path: ProtectedPaths.PROSPECT_SEARCH,
    statKey: "prospects",
    position: [71, 66],
    mobilePosition: [66, 70],
  },
  {
    key: "messages",
    labelKey: TKey.PROJECT_FLOW_MESSAGES,
    path: ProtectedPaths.MESSAGES_CONTENT,
    statKey: "messages",
    position: [89, 38],
    mobilePosition: [36, 90],
  },
];

export type FlowNodeData = FlowStage & {
  label: string;
  count: number;
  reached: boolean;
};

export function buildFlowNodes(
  stages: FlowStage[],
  stats: ProjectOverviewStats,
  t: (key: TKey) => string,
  isMobile: boolean,
): FlowNodeData[] {
  return stages.map((stage) => {
    const count = stats[stage.statKey];
    return {
      ...stage,
      position: isMobile ? stage.mobilePosition : stage.position,
      label: t(stage.labelKey),
      count,
      reached: count > 0,
    };
  });
}
